// Module
var code = "<h2 id=\"debt-management\">Debt Management</h2> <p>Is paying more on your student loan your best option? For more information on the most effective ways to pay down debt, budgeting, and your student loans&mdash;visit YouCanDealWithIt.com.</p> ";
// Exports
export default code;